import { AutogenLayoutBrokeragePlanningProfileList } from "./autogen/AutogenLayoutBrokeragePlanningProfileList";

export class BrokeragePlanningProfileList extends AutogenLayoutBrokeragePlanningProfileList {

    override onLoad() {
        this.mainDataSource.search({});
    }
}
